<template>
	<div :class="['footerBlock', { 'footerBlock--home': homeLayout }]">
		<template v-if="homeLayout">
			<div class="homeFooterContent">
				<img class="homeFooterLogo" src="@/assets/home-footer-logo.png" alt="聚秀科技">
				<div class="homeFooterSolutions">
					<div class="homeFooterHeading">解决方案</div>
					<div class="homeFooterSolutionList">
						<router-link
							v-for="item in solutions"
							:key="item.path"
							:to="item.path"
							class="homeFooterSolution"
						>
							{{ item.name }}
						</router-link>
					</div>
				</div>
				<div class="homeFooterContact">
					<div class="homeFooterHeading">联系我们</div>
					<div class="homeFooterCompany">杭州聚秀科技有限公司</div>
					<div class="homeFooterContactRow">
						<img src="@/assets/home-footer-location.png" alt="">
						<span>杭州市萧山区杭州湾信息港B1栋502室</span>
					</div>
					<div class="homeFooterContactRow">
						<img src="@/assets/home-footer-phone.png" alt="">
						<span>0571-82829806</span>
					</div>
					<a class="homeFooterContactRow" href="mailto:business@hzjuxiu.com">
						<img src="@/assets/home-footer-email.png" alt="">
						<span>business@hzjuxiu.com</span>
					</a>
				</div>
				<div class="homeFooterQr">
					<img src="@/assets/home-footer-qr.png" alt="聚秀数智云二维码">
					<div>聚秀数智云</div>
				</div>
			</div>
			<div class="homeFooterBottom">
				<div class="homeFooterDivider"></div>
				<a target="_blank" rel="noopener" href="https://beian.miit.gov.cn" class="homeFooterRecord">
					<img src="@/assets/guard.png" alt="">
					<span>浙ICP备17037851号</span>
				</a>
			</div>
		</template>
		<template v-else>
			<div class="company_log"></div>
			<div class="company_connect">
				<div class="connect_us">联系我们</div>
				<div class="company_info">
					<div class="company_row company_name">杭州聚秀科技有限公司</div>
					<div class="company_row"><div class="point_icon"></div><span class="info">杭州市萧山区杭州湾信息港B1座502室</span></div>
					<div class="company_row"><div class="dianhua_icon"></div><span class="info">0571-82829806 / 4000802658</span></div>
					<div class="company_row"><div class="email_icon"></div><a href="mailto:business@hzjuxiu.com" class="info">mailto:business@hzjuxiu.com</a></div>
					<a target="_blank" rel="noopener" href="https://beian.miit.gov.cn" class="company_row compant_btmRight"><img src="@/assets/guard.png" alt=""><span class="info">浙ICP备17037851号</span></a>
				</div>
			</div>
			<div class="divide"></div>
			<!-- <div class="company_button">
				<div class="dowithus" @click="contactUs()">与我们合作</div>
			</div> -->
		</template>
	</div>
</template>

<script>
export default {
	props: {
		homeLayout: {
			type: Boolean,
			default: true
		}
	},
	data(){
		return {
			solutions: [
				{ name: '智慧国资', path: '/stateOwnedAssets' },
				{ name: '智慧国企', path: '/stateOwnedEnterprise' },
				{ name: '资产云', path: '/assetCloud' },
				{ name: '智慧好管家', path: '/goodHousekeeper' },
				{ name: '智慧监管', path: '/intelligentSupervision' },
				{ name: '人工智能', path: '/ai' }
			]
		}
	},
	methods: {
		contactUs(){//联系我们
			this.$router.push('/caseTogether')
		}
	}
}
</script>

<style lang="scss" scoped>
.divide{
    position: absolute;
    width: 76%;
    height: 1px;
    opacity: 0.4;
    border: 1px solid #868E99;
    bottom: 52px;
}
.company_name{
    font-size: 24px !important;
}
.compant_btmRight{
    text-decoration: none;
    position: absolute;
    right: 7.15%;
    display: flex;
    align-items: center;
    bottom: 20px;
    img{
        width:11px;
        height: 12px;
    }
}
.footerBlock{
	box-sizing: border-box;
	width: 100%;
    height: 100%;
    padding: 2.92% 16.67%;
    display: flex;
    position: relative;
    .company_log{
        width: 198px;
        height: 55px;
        background: url('/public/img/jxlogo.png');
        background-size: 100% 100%;
    }
    .company_connect{
        // display: flex;
        // flex-direction: column;
        // width: 844px;
        padding-left: 97px;
        text-align: left;
        .connect_us{
            font-size: 24px;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 33px;
            
        }
        .company_info{
            margin-top: 17px;
            .company_row{
                cursor: pointer;
                font-size: 16px;
                font-weight: 400;
                color: #C0C4CC;
                line-height: 25px;
                letter-spacing: 2px;
                display: flex;
                .info{
                    color: #C0C4CC;
                    text-decoration: none;
                    padding-left: 15px;
                }
            }
            .company_row + .company_row{
                padding-top: 20px;
            }
            .point_icon,.dianhua_icon,.email_icon{
                background: url('/public/img/icon/dingwei.png');
                background-size: 100% 100%;
                width: 20px;
                height: 22px;
            }
            .dianhua_icon{
                background: url('/public/img/icon/dianhua.png');
                background-size: 100% 100%;
            }
            .email_icon{
                background: url('/public/img/icon/youxiang.png');
                background-size: 100% 100%;
                width: 23px;
                height: 18px;
                margin-top: 2px;
            }
        }
    }
    .company_button{
        position: absolute;
        right: 7.15%;
        top: 50%;
        transform: translate(0,-50%);
        display: flex;
        // height: 100%;
        align-items: center;
        justify-content: center;
        .dowithus{
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(90deg, #FF795B 0%, #FF8E36 100%);
            box-shadow: 0px 2px 10px 0px rgba(196,165,145,0.25);
            // width: 124px;
            padding: 10px;
            height: 40px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            color: #FFFFFF;
            line-height: 22px;
            overflow: hidden;
            position: relative;
            &::after{
                content: '';
                display: block;
                position: absolute;
                top: -36px;
                left: -100px;
                background: white;
                width: 50px;
                height: 125px;
                opacity: 20%;
                transform: rotate(-45deg);
            }
            &:hover::after{
                left: 120%;
                transition: all 2s cubic-bezier(0.3, 1, 0.2, 1);
            }
        }
    }
}

.footerBlock--home{
	box-sizing: border-box;
	display: block;
	height: 406px;
	padding: 0;
	background: #0D1E33;
	color: #FFFFFF;
	.homeFooterContent{
		position: relative;
		box-sizing: border-box;
		width: 66.66%;
		height: 355px;
		margin: 0 auto;
		padding-top: 59px;
		text-align: left;
	}
	.homeFooterLogo{
		position: absolute;
		top: 59px;
		left: 0;
		display: block;
		width: 198px;
		height: 55px;
	}
	.homeFooterSolutions{
		position: absolute;
		top: 61px;
		left: 43.75%;
	}
	.homeFooterContact{
		position: absolute;
		top: 61px;
		left: 61.55%;
	}
	.homeFooterHeading{
		font-size: 24px;
		font-family: Source Han Sans CN Medium;
		font-weight: 600;
		color: #FFFFFF;
		line-height: 33px;
	}
	.homeFooterSolutionList{
		margin-top: 17px;
	}
	.homeFooterSolution{
		display: block;
		font-size: 16px;
		font-family: Source Han Sans CN Normal;
		font-weight: 400;
		color: #7D8998;
		line-height: 22px;
		text-decoration: none;
		white-space: nowrap;
		cursor: pointer;
	}
	.homeFooterSolution + .homeFooterSolution{
		margin-top: 14px;
	}
	.homeFooterCompany{
		margin-top: 17px;
		font-size: 16px;
		font-family: Source Han Sans CN Medium;
		font-weight: 500;
		color: #7D8998;
		line-height: 22px;
		white-space: nowrap;
	}
	.homeFooterContactRow{
		display: flex;
		align-items: center;
		margin-top: 14px;
		font-size: 16px;
		font-family: Source Han Sans CN Normal;
		font-weight: 400;
		color: #7D8998;
		line-height: 22px;
		letter-spacing: 1px;
		text-decoration: none;
		white-space: nowrap;
		img{
			display: block;
			width: 22px;
			height: 22px;
			margin-right: 14px;
			object-fit: contain;
		}
	}
	.homeFooterQr{
		position: absolute;
		top: 110px;
		right: -49px;
		width: 193px;
		font-size: 16px;
		font-family: Source Han Sans CN Normal;
		font-weight: 400;
		color: #7D8998;
		line-height: 22px;
		text-align: center;
		letter-spacing: 2px;
		img{
			display: block;
			width: 96px;
			height: 96px;
			margin: 0 auto 10px;
		}
	}
	.homeFooterBottom{
		position: relative;
		box-sizing: border-box;
		width: 76%;
		height: 60px;
		margin-left: 16.67%;
	}
	.homeFooterDivider{
		width: 100%;
		height: 1px;
		background: rgba(134, 142, 153, 0.4);
	}
	.homeFooterRecord{
		position: absolute;
		top: 20px;
		right: 0;
		display: flex;
		align-items: center;
		font-size: 12px;
		font-family: Source Han Sans CN Normal;
		font-weight: 400;
		color: #7D8998;
		line-height: 17px;
		text-decoration: none;
		img{
			display: block;
			width: 11px;
			height: 12px;
			margin-right: 8px;
		}
	}
}

</style>
